// Portfolio Data
export interface ProjectData {
  id: string
  title: string
  category: string
  description: string
  image: string
  video?: string
  tags: string[]
  client: string
  year: number
  featured: boolean
  inProgress?: boolean
  liveUrl?: string
}

// Portfolio Data Array
export const portfolioData: ProjectData[] = [

// Web Projects
  // Sunstar Paramedics
  {
    id: 'sunstar-website',
    title: 'Sunstar Paramedics',
    category: 'Web',
    description: 'A clean, responsive web platform for Sunstar, showcasing their services and commitment to community care through a modern, user-friendly design.',
    image: '/assets/portfolio/images/sunstar-website.webp',
    video: '/assets/portfolio/video/sunstar-website.mp4',
    tags: ['Web Development', 'Branding', 'UX/UI'],
    client: 'Sunstar Paramedics',
    year: 2021,
    featured: true,
    liveUrl: 'https://sunstarems.com'
  },
  // PCEMSOMD Websiteç
  {
    id: 'pcemsomd-website',
    title: 'Pinellas County Office of the Medical Director',
    category: 'Web',
    description: 'Modernized platform featuring a professional design and streamlined navigation, built to support Pinellas County EMS providers with essential resources.',
    image: '/assets/portfolio/images/pcemsomd-website.webp',
    tags: ['Web Development', 'Branding', 'UX/UI'],
    client: 'Pinellas County Office of the Medical Director',
    year: 2024,
    featured: false,
    liveUrl: 'https://pcemsomd.com'
  },
  // AMGS Website
  {
    id: 'amgs-website',
    title: 'Appalachian Medical Gas Services',
    category: 'Web',
    description: 'Custom web platform with interactive animations and a premium design approach to elevate the company’s online presence.',
    image: '/assets/portfolio/images/amgs-website.webp',
    tags: ['Web Development', 'Branding', 'UX/UI'],
    client: 'Appalachian Medical Gas Services',
    year: 2025,
    featured: false,
    inProgress: true,
    liveUrl: 'https://amgsllc.com'
  },
  // FL-CEMS Website
  {
    id: 'flcems-website',
    title: 'Florida Center for EMS',
    category: 'Web',
    description: 'Modern, fully responsive website built to highlight EMS education and research with custom animations and a seamless user experience.',
    image: '/assets/portfolio/images/flcems-website.webp',
    tags: ['Web Development', 'Branding', 'UX/UI'],
    client: 'Florida Center for EMS',
    year: 2025,
    featured: true,
    liveUrl: 'https://flcems.org'
  },
  // PMC Group Website
  {
    id: 'prehospital-website',
    title: 'Prehospital Medicine Consultants',
    category: 'Web',
    description: 'Responsive, modern website designed to reflect expertise in prehospital medicine with custom branding and seamless user navigation.',
    image: '/assets/portfolio/images/prehospital-website.webp',
    tags: ['Web Development', 'Branding', 'UX/UI'],
    client: 'Prehospital Medicine Consultants',
    year: 2024,
    featured: false,
    liveUrl: 'https://floridaemsdoctors.com'
  },
  // ICEMS Website
  {
    id: 'icems-website',
    title: 'Innovation Conference for EMS',
    category: 'Web',
    description: 'Dynamic event website designed to capture the future of EMS with a bold, engaging interface and streamlined user experience.',
    image: '/assets/portfolio/images/icems-website.webp',
    tags: ['Web Development', 'Branding', 'UX/UI'],
    client: 'Florida Center for EMS',
    year: 2025,
    featured: false,
    liveUrl: 'https://flcems.org'
  },

// App Projects
  // RefHub App
  {
    id: 'refhub-app',
    title: 'Pinellas County OMD - Reference Hub App',
    category: 'App',
    description: 'Mobile-first application that centralizes protocols and documents, giving providers quick, real-time access to mission-critical resources.',
    image: '/assets/portfolio/images/refhub-app.webp',
    tags: ['App Development', 'UX/UI', 'React.js'],
    client: 'Pinellas County Office of the Medical Director',
    year: 2024,
    featured: false,
    inProgress: false,
    liveUrl: 'https://pcemsomd.com/pcemshub'
  },
  // ICEMS Mobile App
  {
    id: 'icems-app',
    title: 'ICEMS Mobile App',
    category: 'App',
    description: 'A user-focused mobile app designed for the Innovation Conference for EMS, built to maximize engagement and deliver an intuitive conference experience.',
    image: '/assets/portfolio/images/icems-app.webp',
    tags: ['Mobile App', 'UX/UI', 'Product Design'],
    client: 'Florida Center for EMS',
    year: 2025,
    featured: false,
    inProgress: false,
    liveUrl: 'https://prismsolutions.com/app'
  },
  // SeniorityIQ App
  {
    id: 'seniorityiq-app',
    title: 'SeniorityIQ',
    category: 'App',
    description: 'SeniorityIQ is a workforce seniority management platform that automates seniority tracking, ranking, and reporting for EMS and other public safety organizations.',
    image: '/assets/portfolio/images/seniorityiq-app.png',
    tags: ['App Development', 'UX/UI', 'Product Design'],
    client: 'Alt Dev Studios',
    year: 2024,
    featured: true,
    inProgress: false,
    liveUrl: 'https://seniorityiq.com'
  }

]
  
  // Sort projects by featured (featured first), then by year (descending), then title (ascending)
  portfolioData.sort((a, b) => {
    // First, sort by featured status (featured projects first)
    if (a.featured !== b.featured) {
      return b.featured ? 1 : -1;
    }
    // Then by year (descending)
    if (b.year !== a.year) {
      return b.year - a.year;
    }
    // Finally by title (ascending)
    return a.title.localeCompare(b.title);
  });

export const portfolioCategories = ['All', 'Web', 'App', 'Brand']

// Contact Information
export const contactInfo = {
  email: 'info@altdevstudios.com',
  phone: '(727) 600-2369',
  social: {
    instagram: 'https://instagram.com/altdevstudio',
    linkedin: 'https://linkedin.com/company/altdev-studios'
  }
}

// Company Information
export const companyInfo = {
  name: 'AltDev Studios',
  tagline: 'Digital Solutions for Healthcare and EMS Agencies',
  description: 'We craft striking visual experiences that help creative agencies and modern brands stand out in a crowded digital landscape.',
  founded: 2017,
  team: 6,
  projects: 150,
  awards: 25
}
